import React from 'react'
import {
    Steps,
    Button,
    message,
    SuiNumber,
    SuiInput,
    SuiSelect,
    SuiForm,
} from "@sudy/sui-react"
// import optionsStore from './stores/optionsStore';
import optionsStore from '../../stores/optionsStore';
import { Result } from 'antd';
import { observable } from 'mobx';
import { observer } from "mobx-react";
import postStore from '../../stores/postStore';
import { $attrs } from '@sudy/sui-react/lib/sui/bind';
import apis from '../../util/urls'
import $ from 'jquery'
import MessCheck from './messCheck';
import BindPhone from './bindPhone';
import BindEmail from './bindEmail'
import BindWechat from "./BindWechat"
import SetPwd from './setPwd';
import SetOver from './setOver'
import urls from '../../util/urls';
const { Step } = Steps;
let onSubmit ;
const baseurl = window.baseurl;
const subPath = window.subPath;

class AccountAction extends React.Component {
    constructor(props) {
        super(props)
        // this.msgRef = React.createRef()


        this.state = {
            current: 0,
            steps: [],
        }
    }


    /**
     * 设置步骤
     */
    setSteps(data){
        let steps = [
            {
                title: "信息校验",
                id: "messageCheck",
                content: (
                    <MessCheck
                        ref={(node) => {
                            this.MessCheckNode = node
                        }}
                    />
                ),
                url: apis.checkInfo,
                node: this.MessCheckNode,
            }
        ]
        if (data && data.bindPhone) {
            steps = steps.concat([
                {
                    title: "绑定手机",
                    id: "bindPhone",
                    content: (
                        <BindPhone
                            ref={(node) => {
                                this.BindPhoneNode = node
                            }}
                            count={data.smsReInterval}
                        />
                    ),
                    url: apis.bindPhone,
                    node: this.BindPhoneNode || null,
                },
            ])
        }

        if (data && data.bindEmail) {
            steps = steps.concat([
                {
                    title: "绑定邮箱",
                    id: "bindEmail",
                    content: (
                        <BindEmail
                            ref={(node) => {
                                this.BindEmailNode = node
                            }}
                            count={data.emailReInterval}
                        />
                    ),
                    url: apis.bindEmail,
                    node: this.BindEmailNode || null,
                },
            ])
        }

        
        steps = steps.concat([
            {
                title: "设置密码",
                id: "setPwd",
                content: (
                    <SetPwd
                        ref={(node) => {
                            this.SetPwdNode = node
                        }}
                        passRuleInfo={data.passRuleInfo}
                        passLengthInfo={data.passLengthInfo}
                    />
                ),
                url: apis.resetPassword,
                node: this.SetPwdNode || null,
            },
        ])
            
        if (data && data.bindWechat) {
            steps = steps.concat([
                {
                    title: "绑定微信",
                    id: "bindWechat",
                    content: (
                        <BindWechat
                            ref={(node) => {
                                this.BindWechatNode = node
                            }}
                            handle={() => this.handleDone()}
                        />
                    ),
                    url: "",
                    node: this.BindWechatNode || null,
                },
            ])
        }

        steps = steps.concat([
            {
                title: "完成",
                id: "setOver",
                content: (
                    <SetOver
                        ref={(node) => {
                            this.SetOverNode = node
                        }}
                        onClick={() => this.setOver()}
                    />
                ),
                node: this.SetOverNode || null,
            },
        ])

        console.log(steps);

         this.setState({
             current: 0,
             steps: steps,
         })
    }


    /**
     * 获取步骤
     */
    getSteps(){
        const _this = this;

        // _this.setSteps({
        //     bindEmail: true,
        //     passLengthInfo: "密码长度必须为8-50位",
        //     bindPhone: true,
        //     emailReInterval: 120,
        //     passRuleInfo: "密码必须包含字母、数字、特殊字符",
        //     smsReInterval: 120,
        //     fun: true,
        // })


        $.ajax({
            url: urls.getConfig,
            type: "get",
            dataType: "json",
            success: function (response) {
                if (response.resultCode === 0) {
                    if (response.result.data && response.result.data.tipsLink === "") {
                        _this.setSteps(response.result.data)
                    } else {
                        const uri = `${subPath}${response.result.data.tipsLink}`;
                        // alert(uri);
                        window.location.href = uri;
                    }
                    // _this.setState({ current: 0, steps: response.result.data })
                } else {
                    message.warning(response.errorMsg)
                    // _this.MessCheckNode.changeCode()
                }
            },
            error: function (xhr) {
                message.warning("请求异常")
                // _this.MessCheckNode.changeCode()

                // const _current = current + 1
                // _this.setState({ current: _current })
            },
            complete: function () {},
        })
    }

    // 设置完成
    setOver() {
        this.setState({ current:0 })
    }
    // 通过wrappedComponentRef获取子组件的ref
    saveFormRef = (formRef) => {
        this.formRef = formRef
    }
    next() {
        const { current } = this.state
        // this.setState({ current:_current })

        // const pass = this.MessCheckNode.verify()

        this.queryData(current)
    }

    prev() {
        const current = this.state.current - 1
        this.setState({ current })
    }

    // 操作完成时的函数
    handleDone() {
        const { current } = this.state
        // const current = this.state.current + 1
        // this.setState({ current })
        this.queryData(current)
    }

    // 获取参数
    getParams() {
        const _this = this
        const { current } = this.state
        let data = {};
        switch (current) {
            case 0:
                data = _this.MessCheckNode.getValue()
                break
            case 1:
                data = _this.BindPhoneNode.getValue()
                break
            case 2:
                data = _this.BindEmailNode.getValue()
                break
            case 3:
                data = _this.SetPwdNode.getValue()
                break
            case 4:
                data = _this.SetOverNode.getValue()
                break
        }
        console.log(data)
        return data
    }

    queryData(cur) {
        const _this = this
        const { steps, current } = this.state;
        if (steps[cur].url) {
            const data = this.getParams()
            if (data) {
                $.ajax({
                    url: steps[cur].url,
                    type: "post",
                    dataType: "json",
                    data: this.getParams(),
                    success: function (response) {
                        if (response.resultCode === 0) {
                            const _current = current + 1
                            _this.setState({ current: _current })
                        } else {
                            message.warning(response.errorMsg);
                            _this.MessCheckNode.changeCode();
                        }
                    },
                    error: function (xhr) {
                        message.warning("请求异常")
                        _this.MessCheckNode.changeCode()
    
                        // const _current = current + 1
                        // _this.setState({ current: _current })
                    },
                    complete: function () {},
                })
            }
        } else {
            const _current = current + 1
            _this.setState({ current: _current })
        }
    }

    onSubmit() {}

    getValues() {}

    render() {
        const { current, steps } = this.state
        return (
            steps &&
            steps.length > 0 && (
                <div className="steps_container">
                    <Steps current={current}>
                        {steps.map((item) => (
                            <Step key={item.title} title={item.title} />
                        ))}
                    </Steps>
                    <div className="steps-content">
                        {steps[current].content}
                    </div>
                    <div className="steps-action">
                        {/* 倒数第二步骤的时候，显示完成 (有绑定微信步骤时，不显示上一步)*/}

                        {current > 0 &&
                            current < steps.length - 1 &&
                            steps[current].id !== "bindWechat" && (
                                <Button
                                    style={{ margin: 6 }}
                                    onClick={() => this.prev()}
                                >
                                    上一步
                                </Button>
                            )}
                        {current < steps.length - 2 && (
                            <Button
                                type="primary"
                                onClick={() => this.next()}
                                style={{ margin: 6 }}
                            >
                                下一步
                            </Button>
                        )}
                        {current === steps.length - 2 &&
                            steps[current].id !== "bindWechat" && (
                                <Button
                                    type="primary"
                                    style={{ margin: 6 }}
                                    onClick={() => this.handleDone()}
                                >
                                    提交
                                </Button>
                            )}
                    </div>
                </div>
            )
        )
    }

    componentDidMount(){
        this.getSteps()

        // var data = {
        //     result: {
        //         total: 1,
        //         data: {
        //             bindEmail: true,
        //             bindWechat: true,
        //             passLengthInfo: "密码长度必须为8-50位",
        //             bindPhone: true,
        //             emailReInterval: 120,
        //             passRuleInfo: "密码必须包含字母、数字、特殊字符",
        //             smsReInterval: 120,
        //             fun: true,
        //         },
        //     },
        //     resultCode: 0,
        //     errorMsg: null,
        // }
        // this.setSteps(data);
    }
}
export default AccountAction